module.exports = __webpack_public_path__ + "static/07-056e162a2a45d8da5bbe6ee42d49f273.jpg";